import React, { useState } from "react";
import styles from "./searchTeam.module.scss";
import AsyncLookup from "./asynTypeahead";
import { getEnvConfig } from "../../config/config";

const SearchTeam:React.FC = () =>{

    const [selectedTeam, setSelectedTeam] = useState("");

    const teamURL = getEnvConfig().PUBLIC_SEARCH_teamURL;

    const chosenTeam = (val:string) => {
        setSelectedTeam(val);
    };

    const goToTeam = () =>{
        window.open(teamURL+selectedTeam+"&a=Index&c=VenueTeam");
    };

    return(
        <>
            <div className={styles.csTeamSearchSearchBox}>
                
                <label htmlFor="cs-team-search">Find a team</label>
                <div className={styles.csTeamSearchField}>
                        
                    <AsyncLookup setTeam={chosenTeam}></AsyncLookup>
                    <input type="hidden" name="selectedTeam" id="selectedTeam" value={selectedTeam} />
                    <button onClick={()=>{goToTeam()}} disabled={selectedTeam === "" ? true : false} className={selectedTeam === "" ? styles.csTeamSearchDisabled : styles.csTeamSearchEnabled}>Go</button>

                </div>
            </div>
        </>
    )

};

export default SearchTeam;